import { render } from "./TreeNodeModal.vue?vue&type=template&id=17590c42"
import script from "./TreeNodeModal.vue?vue&type=script&lang=js"
export * from "./TreeNodeModal.vue?vue&type=script&lang=js"
script.render = render

export default script